import { BlockEditProps } from "@wordpress/blocks";
import React from "react";
import type { BlockAttributes } from "./block.json";
import {
  InspectorControls,
  RichText,
  useBlockProps,
  useInnerBlocksProps,
} from "@wordpress/block-editor";
import ImageEditor from "../../../source/components/ImageEditor";
import {
  ToggleControl,
  PanelBody,
  PanelRow,
  TextControl,
} from "@wordpress/components";

const ALLOWED_BLOCKS = ["core/video", "core/image"];

export default function HeaderEditor(props: BlockEditProps<BlockAttributes>) {
  const blockProps = useBlockProps({ className: "alignfull" });
  const innerBlocksProps = useInnerBlocksProps(
    useBlockProps({
      className: "",
    }) as unknown as Record<string, unknown>,
    {
      allowedBlocks: ALLOWED_BLOCKS,
    }
  );

  return (
    <>
      <div
        {...blockProps}
        className="header alignfull w-100 bg-dark d-flex flex-column flex-xl-row"
      >
        <div className="w-100 position-relative">
          <div {...innerBlocksProps}></div>
          <div className="container d-flex justify-content-center position-absolute content-container">
            <div className="content py-5">
              <ImageEditor
                attributes={props.attributes}
                setAttributes={props.setAttributes}
                prefix="image"
                placeholderClassName="img-placeholder"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
